import { render } from "./RedirectToDashboard.vue?vue&type=template&id=5718bd9e"
import script from "./RedirectToDashboard.vue?vue&type=script&lang=js"
export * from "./RedirectToDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__